export default __webpack_public_path__ + "static/media/flag-au.1700fc8a.svg";